import * as Types from "../../apollo/graphql.generated";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {};
export type GetAccountSettingsQueryVariables = Types.Exact<{
  [key: string]: never;
}>;

export type GetAccountSettingsQuery = {
  getAccountSettings: {
    __typename: "AccountSettings";
    id: string;
    socials: {
      __typename: "LinkedSocials";
      email: {
        __typename: "LinkedEmail";
        address: string;
        verifiedOn: string | null;
      } | null;
    };
    marketingPreferences: {
      __typename: "MarketingPreferences";
      allowedCreators: Array<{
        __typename: "CreatorDetails";
        id: string;
        walletAddress: string;
        ensName: string | null;
        grantedAccess: string;
        email: boolean;
      }>;
    };
    twitterConnectState: {
      __typename: "TwitterConnectState";
      codeVerifier: string;
      state: string;
    } | null;
  };
};

export type RemoveCreatorMarketingAccessMutationVariables = Types.Exact<{
  creatorId: Types.Scalars["String"];
}>;

export type RemoveCreatorMarketingAccessMutation = {
  removeCreatorMarketingAccess: {
    __typename: "AccountSettings";
    id: string;
    socials: {
      __typename: "LinkedSocials";
      email: {
        __typename: "LinkedEmail";
        address: string;
        verifiedOn: string | null;
      } | null;
    };
    marketingPreferences: {
      __typename: "MarketingPreferences";
      allowedCreators: Array<{
        __typename: "CreatorDetails";
        id: string;
        walletAddress: string;
        ensName: string | null;
        grantedAccess: string;
        email: boolean;
      }>;
    };
  };
};

export type RemoveAllMarketingAccessMutationVariables = Types.Exact<{
  [key: string]: never;
}>;

export type RemoveAllMarketingAccessMutation = {
  removeAllMarketingAccess: {
    __typename: "AccountSettings";
    id: string;
    socials: {
      __typename: "LinkedSocials";
      email: {
        __typename: "LinkedEmail";
        address: string;
        verifiedOn: string | null;
      } | null;
    };
    marketingPreferences: {
      __typename: "MarketingPreferences";
      allowedCreators: Array<{
        __typename: "CreatorDetails";
        id: string;
        walletAddress: string;
        ensName: string | null;
        grantedAccess: string;
        email: boolean;
      }>;
    };
  };
};

export type VerifyEmailMutationVariables = Types.Exact<{
  verifyCode: Types.Scalars["String"];
}>;

export type VerifyEmailMutation = {
  verifyEmail: {
    __typename: "AccountSettings";
    id: string;
    socials: {
      __typename: "LinkedSocials";
      email: {
        __typename: "LinkedEmail";
        address: string;
        verifiedOn: string | null;
      } | null;
    };
    marketingPreferences: {
      __typename: "MarketingPreferences";
      allowedCreators: Array<{
        __typename: "CreatorDetails";
        id: string;
        walletAddress: string;
        ensName: string | null;
        grantedAccess: string;
        email: boolean;
      }>;
    };
  };
};

export const GetAccountSettingsDocument = gql`
  query GetAccountSettings {
    getAccountSettings {
      id
      socials {
        email {
          address
          verifiedOn
        }
      }
      marketingPreferences {
        allowedCreators {
          id
          walletAddress
          ensName
          grantedAccess
          email
        }
      }
      twitterConnectState {
        codeVerifier
        state
      }
    }
  }
`;

/**
 * __useGetAccountSettingsQuery__
 *
 * To run a query within a React component, call `useGetAccountSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountSettingsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAccountSettingsQuery,
    GetAccountSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccountSettingsQuery,
    GetAccountSettingsQueryVariables
  >(GetAccountSettingsDocument, options);
}
export function useGetAccountSettingsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccountSettingsQuery,
    GetAccountSettingsQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccountSettingsQuery,
    GetAccountSettingsQueryVariables
  >(GetAccountSettingsDocument, options);
}
export type GetAccountSettingsQueryHookResult = ReturnType<
  typeof useGetAccountSettingsQuery
>;
export type GetAccountSettingsLazyQueryHookResult = ReturnType<
  typeof useGetAccountSettingsLazyQuery
>;
export type GetAccountSettingsQueryResult = Apollo.QueryResult<
  GetAccountSettingsQuery,
  GetAccountSettingsQueryVariables
>;
export const RemoveCreatorMarketingAccessDocument = gql`
  mutation RemoveCreatorMarketingAccess($creatorId: String!) {
    removeCreatorMarketingAccess(creatorId: $creatorId) {
      id
      socials {
        email {
          address
          verifiedOn
        }
      }
      marketingPreferences {
        allowedCreators {
          id
          walletAddress
          ensName
          grantedAccess
          email
        }
      }
    }
  }
`;
export type RemoveCreatorMarketingAccessMutationFn = Apollo.MutationFunction<
  RemoveCreatorMarketingAccessMutation,
  RemoveCreatorMarketingAccessMutationVariables
>;

/**
 * __useRemoveCreatorMarketingAccessMutation__
 *
 * To run a mutation, you first call `useRemoveCreatorMarketingAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveCreatorMarketingAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeCreatorMarketingAccessMutation, { data, loading, error }] = useRemoveCreatorMarketingAccessMutation({
 *   variables: {
 *      creatorId: // value for 'creatorId'
 *   },
 * });
 */
export function useRemoveCreatorMarketingAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveCreatorMarketingAccessMutation,
    RemoveCreatorMarketingAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveCreatorMarketingAccessMutation,
    RemoveCreatorMarketingAccessMutationVariables
  >(RemoveCreatorMarketingAccessDocument, options);
}
export type RemoveCreatorMarketingAccessMutationHookResult = ReturnType<
  typeof useRemoveCreatorMarketingAccessMutation
>;
export type RemoveCreatorMarketingAccessMutationResult =
  Apollo.MutationResult<RemoveCreatorMarketingAccessMutation>;
export type RemoveCreatorMarketingAccessMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveCreatorMarketingAccessMutation,
    RemoveCreatorMarketingAccessMutationVariables
  >;
export const RemoveAllMarketingAccessDocument = gql`
  mutation RemoveAllMarketingAccess {
    removeAllMarketingAccess {
      id
      socials {
        email {
          address
          verifiedOn
        }
      }
      marketingPreferences {
        allowedCreators {
          id
          walletAddress
          ensName
          grantedAccess
          email
        }
      }
    }
  }
`;
export type RemoveAllMarketingAccessMutationFn = Apollo.MutationFunction<
  RemoveAllMarketingAccessMutation,
  RemoveAllMarketingAccessMutationVariables
>;

/**
 * __useRemoveAllMarketingAccessMutation__
 *
 * To run a mutation, you first call `useRemoveAllMarketingAccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAllMarketingAccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAllMarketingAccessMutation, { data, loading, error }] = useRemoveAllMarketingAccessMutation({
 *   variables: {
 *   },
 * });
 */
export function useRemoveAllMarketingAccessMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveAllMarketingAccessMutation,
    RemoveAllMarketingAccessMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveAllMarketingAccessMutation,
    RemoveAllMarketingAccessMutationVariables
  >(RemoveAllMarketingAccessDocument, options);
}
export type RemoveAllMarketingAccessMutationHookResult = ReturnType<
  typeof useRemoveAllMarketingAccessMutation
>;
export type RemoveAllMarketingAccessMutationResult =
  Apollo.MutationResult<RemoveAllMarketingAccessMutation>;
export type RemoveAllMarketingAccessMutationOptions =
  Apollo.BaseMutationOptions<
    RemoveAllMarketingAccessMutation,
    RemoveAllMarketingAccessMutationVariables
  >;
export const VerifyEmailDocument = gql`
  mutation VerifyEmail($verifyCode: String!) {
    verifyEmail(verifyCode: $verifyCode) {
      id
      socials {
        email {
          address
          verifiedOn
        }
      }
      marketingPreferences {
        allowedCreators {
          id
          walletAddress
          ensName
          grantedAccess
          email
        }
      }
    }
  }
`;
export type VerifyEmailMutationFn = Apollo.MutationFunction<
  VerifyEmailMutation,
  VerifyEmailMutationVariables
>;

/**
 * __useVerifyEmailMutation__
 *
 * To run a mutation, you first call `useVerifyEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useVerifyEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [verifyEmailMutation, { data, loading, error }] = useVerifyEmailMutation({
 *   variables: {
 *      verifyCode: // value for 'verifyCode'
 *   },
 * });
 */
export function useVerifyEmailMutation(
  baseOptions?: Apollo.MutationHookOptions<
    VerifyEmailMutation,
    VerifyEmailMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<VerifyEmailMutation, VerifyEmailMutationVariables>(
    VerifyEmailDocument,
    options
  );
}
export type VerifyEmailMutationHookResult = ReturnType<
  typeof useVerifyEmailMutation
>;
export type VerifyEmailMutationResult =
  Apollo.MutationResult<VerifyEmailMutation>;
export type VerifyEmailMutationOptions = Apollo.BaseMutationOptions<
  VerifyEmailMutation,
  VerifyEmailMutationVariables
>;
